import DashboardLayout from '../../components/layout/DashboardLayout';
import StockTakePanel from '../admin/AutoSpares/StockTakePanel';

/**
 * Standalone Stock Take page — accessible to clerks (with
 * can_view_auto_spares permission), admins, and auto-spares admins.
 * Because sales already auto-decrement product quantity, this
 * effectively becomes a "running stock take" — capture counts any
 * time and variance always reflects live stock.
 */
export default function StockTakePage() {
  return (
    <DashboardLayout>
      <div className="bg-slate-900 -mx-4 lg:-mx-6 -mt-4 lg:-mt-6 px-4 lg:px-6 py-4 min-h-[calc(100vh-4rem)]">
        <StockTakePanel />
      </div>
    </DashboardLayout>
  );
}
